import React from "react";
import { ChevronLeft, ChevronRight } from "react-bootstrap-icons";
import { Button } from "react-bootstrap";
import styles from "./Paginacao.module.css";
import api from "../Api/apiAxios";

const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

const calcularRegistroFinal = (registroInicial, itensPorPagina, quantidadeRegistros) => {
  if (!quantidadeRegistros || quantidadeRegistros <= 0) return 0;
  return Math.min(registroInicial + itensPorPagina - 1, quantidadeRegistros);
};

export const pesquisarPrevious = async ({
  registroInicial,
  urlPesquisa,
  setRegistroInicial,
  setRegistroFinal,
  setRegistrosData,
  itensPorPagina,
  quantidadeRegistros,
}) => {
  const temAnterior = registroInicial > 1;
  if (!temAnterior) return;

  try {
    const novoRegistroInicial = Math.max(1, registroInicial - itensPorPagina);
    const novoRegistroFinal = calcularRegistroFinal(novoRegistroInicial, itensPorPagina, quantidadeRegistros);

    setRegistroInicial(novoRegistroInicial);
    setRegistroFinal(novoRegistroFinal);

    const response = await api.get(
      `${urlPesquisa}&regInicial=${novoRegistroInicial}&itensPorPagina=${itensPorPagina}`
    );

    const dados = response.data?.dados ?? response.data?.itens ?? response.data;
    setRegistrosData(dados);
  } catch (e) {
    console.log(e);
  }
};

export const pesquisarNext = async ({
  registroInicial,
  registroFinal,
  urlPesquisa,
  quantidadeRegistros,
  setRegistroInicial,
  setRegistroFinal,
  setRegistrosData,
  itensPorPagina,
}) => {
  const temProxima = quantidadeRegistros > 0 && registroFinal < quantidadeRegistros;
  if (!temProxima) return;

  try {
    const proximoRegistroInicial = clamp(registroInicial + itensPorPagina, 1, quantidadeRegistros);
    const proximoRegistroFinal = calcularRegistroFinal(proximoRegistroInicial, itensPorPagina, quantidadeRegistros);

    setRegistroInicial(proximoRegistroInicial);
    setRegistroFinal(proximoRegistroFinal);

    const response = await api.get(
      `${urlPesquisa}&regInicial=${proximoRegistroInicial}&itensPorPagina=${itensPorPagina}`
    );

    const dados = response.data?.dados ?? response.data?.itens ?? response.data;
    setRegistrosData(dados);
  } catch (e) {
    console.log(e);
  }
};

export const Paginacao = ({
  registroInicial,
  registroFinal,
  urlPesquisa,
  quantidadeRegistros,
  itensPorPagina,
  setRegistroInicial,
  setRegistroFinal,
  setRegistrosData,
}) => {
  const quantidade = Number(quantidadeRegistros || 0);

  const registroInicialOk = quantidade > 0 ? clamp(Number(registroInicial || 1), 1, quantidade) : 0;
  const registroFinalOk =
    quantidade > 0 ? calcularRegistroFinal(registroInicialOk, Number(itensPorPagina || 20), quantidade) : 0;

  const temAnterior = quantidade > 0 && registroInicialOk > 1;
  const temProxima = quantidade > 0 && registroFinalOk < quantidade;

  const texto = quantidade > 0
    ? `${registroInicialOk} - ${registroFinalOk} de ${quantidade}.`
    : `0 - 0 de 0.`;

  const params = {
    registroInicial: registroInicialOk,
    registroFinal: registroFinalOk,
    urlPesquisa,
    quantidadeRegistros: quantidade,
    itensPorPagina: Number(itensPorPagina || 20),
    setRegistroInicial,
    setRegistroFinal,
    setRegistrosData,
  };

  const handleOnClickPrevious = () => pesquisarPrevious(params);
  const handleOnClickNext = () => pesquisarNext(params);

  return (
    <div className={styles.main}>
      <p className={styles.registros}>{texto}</p>

      <Button
        className={styles.btnPage}
        onClick={handleOnClickPrevious}
        variant="outline-dark"
        disabled={!temAnterior}
      >
        <ChevronLeft size={15} />
      </Button>

      <Button
        className={styles.btnPage}
        onClick={handleOnClickNext}
        variant="outline-dark"
        disabled={!temProxima}
      >
        <ChevronRight size={15} />
      </Button>
    </div>
  );
};
